export type ChildInputType = {
  label: string;
  value: string;
};

export type Enum = {
  groupName?: string;
  code: string;
  description?: string;
  name: string;
  details?: string;
  seq?: number;
  tags?: string[];
  countries?: ChildInputType[] | string[];
  isActive?: boolean;
  inputType?: ChildInputType;
  extCode?: string;
  enumWarn?: boolean;
  orgUnits?: ChildInputType[] | string[];
  type?: string;
  editableByEmp?: boolean;
};

export type AllEnums = {
  [key: string]: Enum[];
};

export enum EnumListKey {
  ABSENCE_LONG_REASON = 'ABSENCE_LONG_REASON',
  ABSENCE_PREVIOUS_REASON = 'ABSENCE_PREVIOUS_REASON',
  ABSENCE_SHORT_REASON = 'ABSENCE_SHORT_REASON',
  ABSENCE_STATUS = 'ABSENCE_STATUS',
  ACKNOWLEDGEMENT_TYPE = 'ACKNOWLEDGEMENT_TYPE',
  ALLOWANCE_TYPE = 'ALLOWANCE_TYPE',
  APPRAISAL_TEMPLATE_TAGS = 'APPRAISAL_TEMPLATE_TAGS',
  BENEFIT_TYPE = 'BENEFIT_TYPE',
  CANDIDATE_STATUS = 'CANDIDATE_STATUS',
  CORE_COMPETENCY = 'CORE_COMPETENCY',
  COLLAB_POST_STATUS = 'COLLAB_POST_STATUS',
  COLLAB_TASK_PRIORITY = 'COLLAB_TASK_PRIORITY',
  COLLAB_TASK_STATUS = 'COLLAB_TASK_STATUS',
  COLLAB_TASK_TYPE = 'COLLAB_TASK_TYPE',
  CONTACT_TYPE = 'CONTACT_TYPE',
  COUNTRY = 'COUNTRY',
  CURRENCY = 'CURRENCY',
  CUSTOM_DATA_TYPE = 'CUSTOM_DATA_TYPE',
  CUSTOM_ENTITY_BILLABLE_HOURS_PAID = 'CUSTOM_ENTITY_BILLABLE_HOURS_PAID',
  CUSTOM_ENTITY_BILLABLE_HOURS_PROPOSAL = 'CUSTOM_ENTITY_BILLABLE_HOURS_PROPOSAL',
  CUSTOM_ENTITY_COST_CENTER = 'CUSTOM_ENTITY_COST_CENTER',
  CUSTOM_ENTITY_DECISION_REGISTRY = 'CUSTOM_ENTITY_DECISION_REGISTRY',
  CUSTOM_ENTITY_EMPLOYEE = 'CUSTOM_ENTITY_EMPLOYEE',
  CUSTOM_ENTITY_EMPLOYEE_POS = 'CUSTOM_ENTITY_EMPLOYEE_POS',
  CUSTOM_ENTITY_EMPLOYMENT = 'CUSTOM_ENTITY_EMPLOYMENT',
  CUSTOM_ENTITY_EMPLOYMENT_DETAILS = 'CUSTOM_ENTITY_EMPLOYMENT_DETAILS',
  CUSTOM_ENTITY_JOB_APPLICATION = 'CUSTOM_ENTITY_JOB_APPLICATION',
  CUSTOM_ENTITY_TIMESHEET = 'CUSTOM_ENTITY_TIMESHEET',
  CUSTOM_ENTITY_UNIT_POSITION = 'CUSTOM_ENTITY_UNIT_POSITION',
  DEV_ACTIVITIES_METHOD = 'DEV_ACTIVITIES_METHOD',
  DEV_ADDITIONAL_PLAN = 'DEV_ADDITIONAL_PLAN',
  DEV_CAREER_ASPIRATION = 'DEV_CAREER_ASPIRATION',
  DEV_COMPETENCY_POS_RELATED = 'DEV_COMPETENCY_POS_RELATED',
  DEV_COMPETENCY_PROFESSIONAL = 'DEV_COMPETENCY_PROFESSIONAL',
  DEV_FOCUS = 'DEV_FOCUS',
  DOCUMENT_APPROVAL_STATUS = 'DOCUMENT_APPROVAL_STATUS',
  DOCUMENT_COMPANY_TYPE = 'DOCUMENT_COMPANY_TYPE',
  DOCUMENT_RESERVED_TYPE = 'DOCUMENT_RESERVED_TYPE',
  DOCUMENT_REW_TYPE = 'DOCUMENT_REW_TYPE',
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  EMAIL_NOTIFY_FREQUENCY = 'EMAIL_NOTIFY_FREQUENCY',
  EMPL_FIXED_TERM_REASON = 'EMPL_FIXED_TERM_REASON',
  EMPL_TERMINATION_REASON = 'EMPL_TERMINATION_REASON',
  EMPLOYEE_POSITION = 'EMPLOYEE_POSITION',
  EMPLOYEE_STATUS = 'EMPLOYEE_STATUS',
  EMPLOYMENT_STATUS = 'EMPLOYMENT_STATUS',
  EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
  EQUIPMENT_TYPE = 'EQUIPMENT_TYPE',
  EVENT_FREQUENCY = 'EVENT_FREQUENCY',
  EXTERNAL_POSITION_TYPE = 'EXTERNAL_POSITION_TYPE',
  EXTERNAL_TRAINING_TYPE = 'EXTERNAL_TRAINING_TYPE',
  GOALS_TEMPLATE_TAGS = 'GOALS_TEMPLATE_TAGS',
  HOURLY_SALARY_COMPONENT = 'HOURLY_SALARY_COMPONENT',
  INCENTIVE_LONG_TYPE = 'INCENTIVE_LONG_TYPE',
  INCENTIVE_SHORT_TYPE = 'INCENTIVE_SHORT_TYPE',
  INTERNAL_TRAINING_TYPE = 'INTERNAL_TRAINING_TYPE',
  JOB_APPLICATION_STATUS = 'JOB_APPLICATION_STATUS',
  JOB_APPLICATION_SOURCE = 'JOB_APPLICATION_SOURCE',
  JOB_GRADE = 'JOB_GRADE',
  JOB_OPENING_STATUS = 'JOB_OPENING_STATUS',
  JOB_OPENING_TYPE = 'JOB_OPENING_TYPE',
  JOB_REQ_TEMPLATE_TAGS = 'JOB_REQ_TEMPLATE_TAGS',
  LOC_CONTENT = 'LOC_CONTENT',
  MODULE_TAB = 'MODULE_TAB',
  NOTIFICATION_TOPIC = 'NOTIFICATION_TOPIC',
  PERF_EMPLOYEE_FEEDBACK_TYPE = 'PERF_EMPLOYEE_FEEDBACK_TYPE',
  PERF_EVAL_RESULT = 'PERF_EVAL_RESULT',
  PERF_GOAL = 'PERF_GOAL',
  PERF_GOAL_SUBGRP_BUGS = 'PERF_GOAL_SUBGRP_BUGS',
  PERF_GOAL_SUBGRP_CONTACTS = 'PERF_GOAL_SUBGRP_CONTACTS',
  PERF_GOAL_SUBGRP_OPERATING_EXPENSES = 'PERF_GOAL_SUBGRP_OPERATING_EXPENSES',
  PERF_GOAL_SUBGRP_OPERATING_PROFIT = 'PERF_GOAL_SUBGRP_OPERATING_PROFIT',
  PERF_GOAL_SUBGRP_REVENUE = 'PERF_GOAL_SUBGRP_REVENUE',
  PERF_GOAL_SUBGRP_SALES = 'PERF_GOAL_SUBGRP_SALES',
  PERF_GOAL_SUBGRP_SALES_2020 = 'PERF_GOAL_SUBGRP_SALES_2020',
  PERF_GOAL_SUBGRP_SERVICE_REVENUE = 'PERF_GOAL_SUBGRP_SERVICE_REVENUE',
  PERF_GOAL_V2 = 'PERF_GOAL_V2',
  PERF_GOAL_V2_SUBGRP_EXPERIENCE_GOAL = 'PERF_GOAL_V2_SUBGRP_EXPERIENCE_GOAL',
  PERF_GOAL_V2_SUBGRP_SKILL_GOAL = 'PERF_GOAL_V2_SUBGRP_SKILL_GOAL',
  PERF_MANAGER_FEEDBACK_TYPE = 'PERF_MANAGER_FEEDBACK_TYPE',
  PERF_NOTES_TYPE = 'PERF_NOTES_TYPE',
  PERF_SELFEVAL_EVAL_QUESTION = 'PERF_SELFEVAL_EVAL_QUESTION',
  PERF_SELFEVAL_WELLBEING_QUESTION = 'PERF_SELFEVAL_WELLBEING_QUESTION',
  PERF_STATUS_DISCUSSION = 'PERF_STATUS_DISCUSSION',
  PERSONNEL_GROUP_NAME = 'PERSONNEL_GROUP_NAME',
  PERSONNEL_GROUP_1 = 'PERSONNEL_GROUP_1',
  PERSONNEL_GROUP_2 = 'PERSONNEL_GROUP_2',
  PERSONNEL_GROUP_3 = 'PERSONNEL_GROUP_3',
  PERSONNEL_GROUP_4 = 'PERSONNEL_GROUP_4',
  PERSONNEL_GROUP_5 = 'PERSONNEL_GROUP_5',
  PLANNING_SUCCESSION_READINESS = 'PLANNING_SUCCESSION_READINESS',
  PROJECT_TYPE = 'PROJECT_TYPE',
  RATING_SCALE = 'RATING_SCALE',
  REW_BILLABLE_PROJECT = 'REW_BILLABLE_PROJECT',
  REW_BILLABLE_TYPE = 'REW_BILLABLE_TYPE',
  REW_SALARY_CLASS = 'REW_SALARY_CLASS',
  REW_SALARY_TYPE = 'REW_SALARY_TYPE',
  SALARY_CHANGE_REASON = 'SALARY_CHANGE_REASON',
  SNAP_TRANSACTION_TYPE = 'SNAP_TRANSACTION_TYPE',
  TEMPLATE_TAGS = 'TEMPLATE_TAGS',
  TIMESHEET_CORRECTION_TYPE = 'TIMESHEET_CORRECTION_TYPE',
  TIMESHEET_NON_WORK_TYPE = 'TIMESHEET_NON_WORK_TYPE',
  TIMESHEET_WORK_TYPE = 'TIMESHEET_WORK_TYPE',
  TRAINING_CLASS = 'TRAINING_CLASS',
  UI_LABEL = 'UI_LABEL',
  UNIT_TYPE = 'UNIT_TYPE',
  VACATION_BALANCE_LABEL = 'VACATION_BALANCE_LABEL',
  VACATION_BANK_LABEL = 'VACATION_BANK_LABEL',
  WORKFLOW_CAPABILITY = 'WORKFLOW_CAPABILITY',
  WORKFLOW_ITEM_STATUS = 'WORKFLOW_ITEM_STATUS',
  WORKING_HOURS_TYPE = 'WORKING_HOURS_TYPE',

  // ??? Custom enums? Maybe shouldn't be part of this key list
  __USER__DEV_JOB_EVALUATION_GROUP_1 = '__USER__DEV_JOB EVALUATION GROUP 1',
  __CUSTOMDATA__EMPLOYEE__T_PAIDAN_KOKO = '__CUSTOMDATA__EMPLOYEE__T_PAIDAN_KOKO',
  __USER__DEV_EXPERIENCE = '__USER__DEV_EXPERIENCE',
}
